export const Droppables = {
  SECTION: "section",
  FIELD: "field",
  ALL: "all",
};
